import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ImagedSection extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }

  get text() {
    return get(this, '_text', '');
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/ImagedSection.model.js